module.exports = __webpack_public_path__ + "3fe66459a4162e3c8fdbf49901f3bf4f.svg";